import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-adobe-modal',
  templateUrl: './adobe-modal.component.html',
  styleUrls: ['./adobe-modal.component.scss'],
})
export class AdobeModalComponent {
  constructor(private dialogRef: MatDialogRef<AdobeModalComponent>) {}

  close() {
    this.dialogRef.close();
  }

  isModalOpen = false;
  selectedImage: string = '';

  openImage(event: MouseEvent) {
    const imgElement = event.target as HTMLImageElement;
    this.selectedImage = imgElement.src;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
}
